<template>
  <form action="#">
    <label :data-state="state">
      <input
        type="text"
        placeholder="Search Software"
        v-model="searchKey"
        ref="searchKey"
        @click="state = 'open'"
        @blur="state = 'close'"
        @keyup.enter="search"
      />
      <v-icon :color="config.light.iconColor" size="28">mdi-magnify</v-icon>
    </label>
  </form>
</template>

<script>
  import config from '../../config'

  export default {
    name: 'Search',
    data() {
      return {
        config,
        state: 'close',
        searchKey: ''
      }
    },
    methods: {
      search: function () {
        if (!this.searchKey) {
          this.$refs.searchKey.focus()
          return
        }
        window.open(
          'https://software.space-registry.org/registry/' +
            this.searchKey.toUpperCase(),
          '_blank'
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/styles.sass';

  label {
    @include media-breakpoint-up(md) {
      display: inline-block;
    }
    display: none;
    position: relative;
    background-color: transparent;
    padding: 5px 12px;
    transition: all 300ms ease;
    border-radius: 0;

    input {
      transition: width 0.3s ease, opacity 0.3s ease 0.3s;
      opacity: 1;
      margin-left: 10px;
      margin-right: -25px;
      padding: 0 15px;
      background-color: rgba(255, 255, 255, 0.08);
      width: 230px;
      height: 35px;
      border: 0;
      border-radius: 30px;
      outline: none;
      color: white;
      &::placeholder {
        font-weight: 400;
        font-size: 16px;
      }
    }
    i {
      position: absolute;
      right: 10px;
      color: rgba(255, 255, 255, 0.35);
      cursor: pointer;
    }
    &[data-state='close'] {
      border-radius: 30px;
      padding: 5px 5px;
      transition: all 0.3s ease;

      &::after {
        width: 0;
        transition: all 0.3s ease;
      }
      i {
        pointer-events: none;
      }
      input {
        width: 28px;
        height: 35px;
        opacity: 0;
        cursor: pointer;
        transition: opacity 0.3s ease, width 0.3s ease;
        -webkit-appearance: none;
      }
    }
  }
</style>
